import "./Bogota.module.css";
import Header from "@/reusable_sections/Header";
import HeroShowcase from "./sections/HeroShowcase";
import ExclusiveExperiences from "./sections/ExclusiveExperiences";
import SignaturePartnerships from "./sections/SignaturePartnerships";
import BookYourLuxuryExperience from "./sections/BookYourLuxuryExperience";
import ExperienceInquiry from "./sections/ExperienceInquiry";
import Footer from "@/reusable_sections/Footer";
export default function BogotaPage() {
  return <div>
      <Header />
      <HeroShowcase />
      <ExclusiveExperiences />
      <SignaturePartnerships />
      <BookYourLuxuryExperience />
      <ExperienceInquiry />
      <Footer />
    </div>;
}